export default {
    created() {
        window.dataLayer = window.dataLayer || [];
    },
    methods: {
        gaClick: function(item = null, context) {
            if(!item)item = this.tripData;
            if(item.code){
                this.gaProductClick(item, context);
            } else {
                this.gaPromotionClick(item, context);
            }
        },
        gaProductClick: function(item = null, context) {
            if(!item)item = this.tripData;
            window.dataLayer.push({
                'event': 'productClick',
                'isInternal': window.isInternal,
                'ecommerce': {
                    'click': {
                        'actionField': {'list': context},
                        'products': [{
                            'name': item.tdbez,
                            'id': item.code,
                            'price': item.price,
                            'brand': item.mandantname,
                            'category': item.reiseart,
                            'variant': '',
                            'position': ''
                        }]
                    }
                },
                'eventCallback': function () {
                    document.location = link;
                }
            });
        },
        gaPromotionClick: function(item = null, context){
            if(!item)item = this.tripData;
            window.dataLayer.push({
                'event': 'promotionClick',
                'isInternal': window.isInternal,
                'ecommerce': {
                    'promoClick': {
                        'promotions': [{
                            'name': this.tripData.tdbez,
                            'id': this.tripData.code,
                            'creative': context,
                            'position': ''
                        }]
                    }
                },
                'eventCallback': function () {
                    document.location = link;
                }
            });
        },
        gaImpressions: function(items = [], context, posOffset = 0){
            if(items.lenght == 0)items = this.travelData;
            var promos = [];
            var impressions = []
            items.forEach(function(item, idx){
                if(item.code){
                    impressions.push({
                        'name': item.tdbez,
                        'id': item.code,
                        'price': item.price,
                        'brand': item.mandantname,
                        'category': item.reiseart,
                        'list': context,
                        'position': (idx + posOffset)
                    });
                } else {
                    promos.push({
                        'name': (item.tdbez)?item.tdbez:item.overrides.title,
                        'creative': item.code,
                        'position': (idx + posOffset)
                    });
                };
            });
            if(impressions.length > 0)window.dataLayer.push({
                'event': 'productImpressions',
                'isInternal': window.isInternal,
                'ecommerce': {
                    'impressions': impressions
                }
            });
            if(promos.length > 0)window.dataLayer.push({
                'event': 'promotionImpressions',
                'isInternal': window.isInternal,
                'ecommerce': {
                    'promoView': {
                        'promotions': promos
                    }
                }
            });
        },
        gaProductDetailView: function(item = null){
            if(!item)item = this.tripData;
            window.dataLayer.push({
                'event': 'productDetailView',
                'isInternal': window.isInternal,
                'ecommerce': {
                    'detail': {
                        'actionField': {},
                        'products': [{
                            'name': item.tdbez,
                            'id': item.code,
                            'price': item.minPrice,
                            'brand': item.mandantname,
                            'category': item.reiseart,
                            'variant': ''
                        }]
                    }
                }
            });
        }
    },
    mounted(){

    }
};